import React, { useContext, useEffect, useState } from "react";
import SocketContext from "../../../../context/SocketContext";

export default function Change({ symbol_id, type, adv, digit}) {
  const socket = useContext(SocketContext);
  const [change, setChange] = useState(0);
  const [percent, setPercent] = useState(0);

  useEffect(() => {
    if (!socket || !symbol_id) return;

    socket.emit("giverate", symbol_id);

    const tradeListener = (data) => {
      if (data && data.LTP != null && data.Previous_Close != null) {
        const ch = data.LTP - data.Previous_Close;
        const pct = (ch / data.Previous_Close) * 100;
        setChange(ch);
        setPercent(pct);
      }
    };

    socket.on(`trade${symbol_id}`, tradeListener);

    return () => {
      socket.off(`trade${symbol_id}`, tradeListener);
    };
  }, [socket, symbol_id, type]);

  const formattedChange = change.toFixed(digit);
  const formattedPercent = percent.toFixed(2);

  let tickColor =
    formattedPercent > 0 ? "text-[var(--buymeta)]" : "text-[var(--sellmeta)]";

  return (
    <>
      {adv ? (
        <span
          className={`text-right  font-semibold transition-all duration-300 ${tickColor}`}
        >
          {formattedChange}
        </span>
      ) : null}

      <span
        className={`text-right text-[12px] ${
          adv ? "pl-1.5 " : null
        } font-semibold transition-all duration-300 ${tickColor}`}
      >
        {formattedPercent}%
      </span>
    </>
  );
}
